import { IntlShape } from 'react-intl'
import { create, enforce, omitWhen, test } from 'vest'
import { MoreForLessEffect } from '../../../../typings'
import { benefitValidationSuite } from './Editor/Benefit/validation'
import { triggerValidationSuite } from './Editor/Trigger/validation'
import { messages } from './messages'

export function triggerSuite(intl: IntlShape, name: string) {
  const { $t } = intl
  return create((config: MoreForLessEffect) => {
    test(name, $t(messages.validation.empty), () => {
      enforce(config.trigger).isNotUndefined()
    })

    omitWhen(!config.trigger, () => {
      test(`${name}.trigger`, $t(messages.validation.generic), () => {
        enforce(
          triggerValidationSuite(intl)(
            config as NonNullableObject<MoreForLessEffect>
          ).isValidByGroup('trigger')
        ).isTruthy()
      })
    })
  })
}

export function benefitSuite(intl: IntlShape, name: string) {
  const { $t } = intl
  return create((config: MoreForLessEffect) => {
    test(name, $t(messages.validation.empty), () => {
      enforce(config.benefit).isNotUndefined()
    })

    omitWhen(!config.benefit, () => {
      test(`${name}.benefit`, $t(messages.validation.generic), () => {
        enforce(
          benefitValidationSuite(intl)(
            config as NonNullableObject<MoreForLessEffect>
          ).isValidByGroup('benefit')
        ).isTruthy()
      })
    })
  })
}
